import Tippy from "@tippyjs/react";
import { FaLock } from "react-icons/fa";

interface MaskedFieldValueProps {
  field: string;
}

const MaskedFieldValue: React.FC<MaskedFieldValueProps> = ({ field }) => {
  return (
    <div className="masked-field-value-container">
      <Tippy content={`Masked before purchase: ${field}`}>
        <FaLock />
      </Tippy>
    </div>
  );
};

export default MaskedFieldValue;
